export const LOGGER = {
	log: (...args) => {
		console.log(...args)
	},

	error: (...args) => {
		console.error(...args)
	},

	warn: (...args) => {
		console.warn(...args)
	}
}
